import {isBoolean, isObject} from 'lodash';

interface AutoTerminationSource {
    auto_release?: unknown;
    sandbox_exists?: unknown;
    charge_info?: {
        usedCredits?: number | null;
        refundedCredits?: number | null;
        recycling_time?: string;
    };
}

interface RecoveryJobState {
    isRecovery: boolean;
    isAutoTerminated: boolean;
    sandboxExists: boolean;
}

export interface AutoTerminationState {
    isAutoTerminated: boolean;
    sandboxExists: boolean;
    consumedCredit?: number | null;
    refundedCredit?: number | null;
}

function getAutoReleaseInfo(autoRelease?: unknown): Record<string, any> | null {
    if (!isObject(autoRelease)) {
        return null;
    }

    const autoReleaseInfo = autoRelease as Record<string, any>;
    return Object.keys(autoReleaseInfo).length > 0 ? autoReleaseInfo : null;
}

function isPausedSettleTtlDelete(autoReleaseInfo: Record<string, any> | null): boolean {
    return autoReleaseInfo?.reason === 'paused_settle_ttl_expired'
            && String(autoReleaseInfo?.action).toLowerCase() === 'delete';
}

export function getAutoTerminationState(source: AutoTerminationSource): AutoTerminationState {
    const autoReleaseInfo = getAutoReleaseInfo(source.auto_release);
    const isAutoTerminated = isPausedSettleTtlDelete(autoReleaseInfo);

    return {
        isAutoTerminated,
        sandboxExists: isBoolean(source.sandbox_exists) ? source.sandbox_exists : false,
        consumedCredit: autoReleaseInfo?.settled_cost
            ?? autoReleaseInfo?.usedCredits
            ?? null,
        refundedCredit: autoReleaseInfo?.released_credit
            ?? autoReleaseInfo?.refundedCredits
            ?? null
    };
}

export function shouldRecoverBeforeEnterJob(job: RecoveryJobState): boolean {
    return job.isRecovery;
}

export function shouldRecoverTerminated(job: RecoveryJobState): boolean {
    return job.isRecovery && (job.isAutoTerminated || !job.sandboxExists);
}
